let that;
import { dwgl } from '@/axios'
import { Message } from 'element-ui'
import dataBank from '@/components/databank.vue'
import localBank from '@/components/localAdd.vue'
import AddTags from '../components/addTag.vue'
export default{
	data(){
		return{
			imageUrl:"",
			isUploaded:"上传封面图",
			typeList:[],
			dialogVisible:false,//资料库弹窗
			showlocal:false,
			tagsWin:false,//自定义标签弹窗
			dynamicTags:[
				{
					name:"主题党日",
					checked:false
				},
				{
					name:"民主生活会",
					checked:false
				},
				{
					name:"组织生活会",
					checked:false
				},
			],
			inputVisible: false,
			inputValue: '',
			formData:{
				dw:this.$store.state.user.userinfo.dw,
				flag:this.$store.state.user.userinfo.flag,
				user_id:this.$store.state.user.userinfo.id,
				title:"",
				u_id:[],
				tid:"",
				h_stime:"",
				h_address:"",
				sz_img:"",
				hour:0,
				file:[],
				focus:2,// 1：集中学习  2：关闭
				tips:2,//1：开启心得体会  2：关闭
				record:"",
				hyid:"",
				sync_label:[],
				branch :"1",// branch  1：支部会议，2：个人会议
				assessment: 2, //assessment 否开启是考核，1：开启，2：不开启
				assess_id:""// 考核id
			},
			zzlist:[],
			props: { multiple: true },
			rules:{
				// 检测标题是否为空
				title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
				// 检测活动时间是否为空
				h_stime: [{ required: true, message: '请选择活动时间', trigger: 'blur' }],
				// 检测活动类型是否为空
				tid: [{ required: true, message: '请选择活动类型', trigger: 'blur' }],
				// 检测活动地址是否为空
				h_address: [{ required: true, message: '请输入活动地点', trigger: 'blur' }],
				// 检测活动组织是否为空
				u_id:[{ required: true, trigger: 'blur',  message: '请选择参与组织' }],
				// 检测活动记录是否为空
				record:[{ required: true, trigger: 'blur',  message: '请输入活动记录' }],
			}
		}
	},
	components:{dataBank,localBank,AddTags},
	methods:{
		// 获取数据
		getdata(){
			
		},
		// 标签
		handleClose(tag) {
			this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
		},
		addtgs(data){
			//增加标签
			that.dynamicTags = [...that.dynamicTags,data]
			that.closeTagWin()
		},
		// 关闭标签弹窗
		closeTagWin(){
			that.tagsWin = false;
		},
		// 组织选择
		szzlist(value){
			that.formData.u_id = value
		},
		// 关闭资料库弹窗
		closeEdit(){
			that.dialogVisible = false;
		},
		// 关闭本地
		closeLocal(){
			that.showlocal = false;
		},
		// 本地文件数组
		pushData(file){
			this.formData.file.push(file)
		},
		//删除文件
		delfile(index){
			this.formData.file.splice(index,1);
		},
		// 编辑绑定数据
		bindData(){
			dwgl.updateActivity({
				hyid:that.$route.query.hyid,
				flag:that.$route.query.hy_flag,
				pub_flag:that.$route.query.pub_flag
			}).then(res => {
				if(res.data.sz_img!=''&&res.data.sz_img!=null){
					that.imageUrl = res.data.sz_img;
					that.isUploaded = "重新上传"
				}
				if(res.data.sync_label.length>0){
					for(let i=0;i<res.data.sync_label.length;i++){
						res.data.sync_label[i] = {
							name:res.data.sync_label[i],
							checked:true
						}
						that.dynamicTags.find(item => {
							if(item.name == res.data.sync_label[i].name){
								item.checked = true;
							}
						})
					}
				}
				that.formData = res.data;
				that.dynamicTags = [...that.dynamicTags,...that.formData.sync_label];
				let obj = {};
				that.dynamicTags= this.dynamicTags.reduce((cur,next) => {
					obj[next.name] ? "" : obj[next.name] = true && cur.push(next);
					return cur;
				},[]);
				that.formData.dw = this.$route.query.dw;
				that.formData.flag = this.$route.query.flag;
				that.formData.user_id = this.$route.query.uid;
			
			})
		},
		// 资源库文件数组
		pushData1(fileList){
			this.formData.file = this.formData.file.concat(fileList)
		},
		//提交
		submit(formData){
			that.$refs[formData].validate((valid) => {
				if (valid) {
					that.formData.sync_label = [];
					that.dynamicTags.forEach(item => {
						if(item.checked){
							that.formData.sync_label.push(item.name)
						}
					})
					if(that.formData.record!=""){
						that.formData.status = 2;
					}else{
						that.formData.status = 1;
					}
					if(that.$route.query.type == 'edit'){
						// 编辑
						dwgl.updateActivity1(that.formData).then(res => {
							if(res.code == 200){
								that.$router.go(-1);
							}else{
								Message({
									type:"error",
									message:res.msg
								})
							}
						})
					}else{
						// 新增
						dwgl.addActivity(that.formData).then(res => {
							if(res.code == 200){
								that.$router.go(-1);
							}else{
								Message({
									type:"error",
									message:res.msg
								})
							}
						})
					}
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		// 上传封面图成功
		success(res, file) {
			if(res.code == 200){
				that.imageUrl = URL.createObjectURL(file.raw);
				that.isUploaded = "重新上传"
				that.formData.sz_img = res.data.src
			}else{
				Message({
					type:"error",
					message:"上传失败，请检查文件或网络连接"
				})
			}
		},
		// 参与组织列表
		organMember(){
			dwgl.organMember({
				flag:that.$store.state.user.userinfo.flag,
				user_id:that.$store.state.user.userinfo.id
			}).then(res => {
				that.zzlist = res.data;
			})
		}
	},
	mounted() {
		if(that.$route.query.type == 'edit'){
			that.getdata();
		}
		// 活动类型分类筛选列表
		dwgl.hyClass().then(res => {
			that.typeList = res;
		});
		that.organMember();
		if(that.$route.query.type == 'edit'){
			that.bindData();
		}
	},
	created() {
		that = this;
		that.$emit('selectTop',3)
	}
}